import JobPage from './JobPage.vue';

export default function JobRoutes() {
  return [
    {
      path: ':id',
      component: JobPage,
      name: 'jobDetail'
    }
  ]
}
